import { Link } from 'gatsby';
import React from 'react';
import { ArrowButton } from '@hover/shared-components';

const WorkWithUs: React.FC = () => (
  <ArrowButton
    colorScheme="primary"
    variant="minimal"
    mb={{ base: 400, tablet: 0 }}
    as={Link}
    to="/careers/"
    sx={{
      // TODO(buttons): remove when we remove padding in Blueprint
      div: { pl: 0, pr: 50 },
    }}
  >
    Work with us
  </ArrowButton>
);

export default WorkWithUs;
